import React from "react";
import Reveal from "./Reveal";
import rainBird from "../assets/images/rain-bird.png";
import tl from "../assets/images/tl.png";
import sylwan from "../assets/images/sylwan.png";

// Se usan los logos por separado (antes era una sola imagen con los tres juntos,
// que se veía borrosa y no se podía adaptar a pantallas chicas).
const brands = [
  { name: "Rain Bird", logo: rainBird },
  { name: "T-L Irrigation", logo: tl },
  { name: "Sylwan", logo: sylwan },
];

const Suppliers = () => {
  return (
    <section className="border-y border-slate-100 bg-white py-16">
      <div className="container-site">
        <Reveal className="text-center">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">
            Marcas que representamos
          </p>
        </Reveal>

        <Reveal delay={100}>
          {/* Cada logo va en una caja del mismo tamaño (con object-contain) en vez
              de solo igualar la altura: así todas las marcas ocupan el mismo
              espacio visual sin importar la relación de aspecto de su logo
              (el de T-L es más cuadrado que el de Rain Bird, por ejemplo). */}
          <ul className="mt-10 flex flex-wrap items-center justify-center gap-x-10 gap-y-8">
            {brands.map((brand) => (
              <li
                key={brand.name}
                className="flex h-16 w-32 items-center justify-center sm:h-20 sm:w-40"
              >
                <img
                  src={brand.logo}
                  alt={`Logo de ${brand.name}`}
                  loading="lazy"
                  decoding="async"
                  className="max-h-full max-w-full object-contain opacity-50 grayscale transition-all duration-300 hover:opacity-100 hover:grayscale-0"
                />
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};

export default Suppliers;
